export default __webpack_public_path__ + "static/media/demo-10.0df10429.png";